import belvillageEng from "./belvillage/en.json";
import belvillageIta from "./belvillage/it.json";
import { ICaseStudyContent } from "./index";
import nowrEng from "./nowr/en.json";
import nowrIta from "./nowr/it.json";
import startupGeeksEng from "./startup-geeks/en.json";
import startupGeeksIta from "./startup-geeks/it.json";

export const localCaseStudies: {
  [x: string]: { it: ICaseStudyContent; en?: ICaseStudyContent };
} = {
  "startup-geeks": {
    it: startupGeeksIta as any,
    en: startupGeeksEng as any,
  },
  nowr: {
    it: nowrIta as any,
    en: nowrEng as any,
  },
  belvillage: {
    it: belvillageIta as any,
    en: belvillageEng as any,
  },
};

export const filterCaseStudiesForLocale = (locale: "it" | "en") => {
  return Object.keys(localCaseStudies)
    .filter((caseStudyId) => !!localCaseStudies[caseStudyId][locale])
    .map((caseStudyId) => ({
      slug: caseStudyId,
      ...(localCaseStudies[caseStudyId][locale] as ICaseStudyContent),
    }));
};
